import React, { useEffect, useState } from "react";
import Icons from "../Icons/Icons";
import { isSet, parameterizedURLAccessToken } from "../../Utils/CommonFunctions";

const PreviewHtml = (props)=>{
    const {isPreviewModal,onToogleHandlerPreview,viewTypes,htmlContentItems} = props;
    let getHtmlContentItems = {...props.htmlContentItems}
    const [innerHtml,setInnerHtml] = useState('');
    const openclassName = (isPreviewModal===true)?'open':'';
    //console.log('isPreviewModal==',isPreviewModal)
    useEffect(()=>{
        if(isPreviewModal===true){
            let tagName   = (getHtmlContentItems.hasOwnProperty('name')===true)?getHtmlContentItems.name:'';
            const attribs = (getHtmlContentItems.hasOwnProperty('attributes')===true)?getHtmlContentItems.attributes:{};
            let attributes ={
                ...attribs,
                id:isSet(getHtmlContentItems.id,0)
            }
            // const innertht  = props.convertAndCreateElement(htmlContentItems.children);
            // console.log('innerHtml===',innertht)
            let innerDom =  React.createElement(tagName, {...attributes}, convertAndCreateElement(getHtmlContentItems.children,{loopData:[],dynamicVar:{}}));            
            setInnerHtml(innerDom);
        }else{
            setInnerHtml('');
        }
    },[isPreviewModal]);

    const convertAndCreateElement = (htmlElement)=>{
        let notAllowingTagReplacement = {'html':'manualhtml','meta':'manualheta','title':'manualtitle','script':'manualscript'};
        let notAllowingTag = ['html','meta','title','script'];
        return htmlElement.map((item,itemIndex)=>{
              const {children} = item;
              const attribs = (item.hasOwnProperty('attributes')===true)?item.attributes:{};
              let attributes ={
                ...attribs,
                data:isSet(item.data,[]),
                id:isSet(getHtmlContentItems.id,itemIndex)
              }
              let tagName   = (item.hasOwnProperty('name')===true)?item.name:'';
              let tagLabel   = (item.hasOwnProperty('label')===true)?item.label:'';
              //console.log('tagLabel==',tagLabel)
              if(notAllowingTag.indexOf(tagName)!==-1){
                tagName = notAllowingTagReplacement[tagName];
              }
              switch (tagName) {
                  case "img":
                    const src = (isSet(attributes.src,null)===null)?'/assets/img/temp-banner.png':parameterizedURLAccessToken(attributes.src);
                    return React.createElement('div',{style:attributes.style},React.createElement(tagName, {...attributes,src:src}));
                  default:
                    if(children.length===0){
                        return React.createElement(tagName, {...attributes},isSet(item.data,''));
                    }else{
                        return React.createElement(tagName, {...attributes}, convertAndCreateElement(children));
                    }
              }
        })
      }
       
    return(
        <div className={'filterTemp ' +openclassName} style={{zIndex:'9999'}}>
				<div className="title d-flex align-item-center justify-content-center">
					<div className="selectgroup selectgroup-default border rounded">
                    {viewTypes.map((type,typeIndex)=>{
                        return(
                            <label className="selectgroup-item" key={typeIndex}>
                            <input type="radio" name="value" className="selectgroup-input" />
                            <Icons iconType={type.svgIcon} />
                            </label>
                        )
                        })}
					</div>
				</div>
				<div className="view view-xl" style={{height:'calc(-55px + 100vh)'}}>
					<div className="table_Box">
						<div className="table_Body" style={{display:'flex',alignItems:'flex-start',justifyContent:'center'}}>
							<div className="card" style={{padding:'10px',width:'100%'}}>
							   {innerHtml}
							</div>

						</div>
						<div className="table_Footer">
							<a  onClick={()=>onToogleHandlerPreview()}
                                className="btn btn-cancel filterToggle"> 
                                Close 
                            </a> 
						</div>
					</div>
				</div>
			</div>
    )
}

export default PreviewHtml;